export const CHECKOUT_PAYMENT_METHOD = {
  PAY_IMMEDIATELY: 'pay_immediately',
  PAY_ON_RECEIPT: 'pay_on_receipt',
};

export const CHECKOUT_TOKEN = {
  PAY_ON_RECEIPT: 'PAY_ON_RECEIPT',
};

export const CHECKOUT_OUTCOME = {
  SUCCESS: 'Success',
  PENDING: 'Pending',
  PAYMENT_FAILED: 'PaymentFailed',
  PARTIAL_FAILURE: 'PartialFailure',
  INVOICE_GENERATED: 'InvoiceGenerated',
};

// sessionStorage key for the /checkout/review order kept across a page refresh
// (useReviewOrderState). Also cleared on logout and on a firm/site switch (clearReviewOrderCopy), so it
// never outlives the session or the scope it was started in.
export const REVIEW_ORDER_STORAGE_KEY = 'checkout-review-order';
